// src/app/core/guards/two-fa.guard.ts
import { CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

import { environment } from '@enviroment/environment';
import { TwoFactorService } from '@core/service/two-factor.service';
import { AuthManagementService } from '@core/service/auth-management.service';
import { TwoFaDialogComponent } from '@shared/components/two-fa-dialog/two-fa-dialog.component';

export const twoFaGuard: CanActivateChildFn = async () => {
  // ✅ DEV: si está deshabilitado, NO pedir 2FA jamás
  if (!environment.twoFAEnabled) return true;

  const twofa = inject(TwoFactorService);
  const authMng = inject(AuthManagementService);
  const dialog = inject(MatDialog);
  const router = inject(Router);

  try {
    const ok = await twofa.ensure2FA(async (sendFn) => {
      await sendFn();

      const ref = dialog.open(TwoFaDialogComponent, {
        disableClose: true,
        autoFocus: true
      });

      const code = await firstValueFrom(ref.afterClosed());
      return (code ?? null) as string | null;
    });

    if (!ok) {
      authMng.hardLocalLogout();
      router.navigateByUrl('/authentication/signin', { replaceUrl: true });
      return false;
    }

    return true;
  } catch {
    authMng.hardLocalLogout();
    router.navigateByUrl('/authentication/signin', { replaceUrl: true });
    return false;
  }
};
